import { Subject } from 'rxjs';

export const subject = new Subject();